import React from "react";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
    Icon,
    Grid,
    Button,
    Card,
    Image,
    GridColumn,
    Dropdown,
    Label,
    Modal,
    Form,
    Input,
    Dimmer,
    Loader
} from "semantic-ui-react";
import processIcon from "../../../Images/process.png";
import excel from "../../../Images/excel_icon.png";
import {
    fetchRetailingPSR,
    fetchTemplates,
    getRetailingExtractionStatus,
    getVisibilityReportStatus,
    getOneOffInputUploadStatus,
    oneOffFinalWorking,
    getoneOffFinalWorkingStatus,
    extractRetailingData
} from '../../../actions/users_action';
import ButtonHandler from "../../ButtonHandler.jsx";
import config from "../../../config.js";
const storageBaseUrl = config["storage_base_url"];

var apiTimeout = null
class Automation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDisbursement: '',
            initial: true,
            fileType: '',
            fileName: '',
            modalOpen: false,
            templateId: '',
            templates: [],
            extractionStatus: 'Pending',
            selectedTemplate: '',
            fileUrl: '',
            visibilityReportStatus: 'Pending',
            visibilityReportUrl: '',
            inputUrl: '',
            workingStatus: 'Pending',
            downloadEnable: false,
            psrInitial:true
        };
    }

    async componentDidMount() {
        await this.props.fetchTemplates({
            onSuccess: (res) => {
                console.log(res, 'rs')

                this.props.getRetailingExtractionStatus(res.templates[res.templates.length - 1]['_id'],
                    {
                        onSuccess: (res) => {
                            if (res?.res.status) {
                                this.setState({ extractionStatus: res.status, fileUrl: res.fileUrl })
                            }

                        },
                        onFailure: () => {

                        }
                    }
                )
                this.props.getVisibilityReportStatus(res.templates[res.templates.length - 1]['_id'],
                    {
                        onSuccess: (res) => {
                            this.setState({ visibilityReportStatus: res.status, visibilityReportUrl: res.fileUrl })
                        },
                        onFailure: () => {

                        }
                    }
                )

                this.props.getoneOffFinalWorkingStatus(res.templates[res.templates.length - 1]['_id'], {
                    onSuccess: (res) => {

                        if (res.status == 'Completed') {
                            this.setState({ 'workingStatus': res.status, 'workingUrl': res.fileUrl, initial: false, downloadEnable: true })
                            clearTimeout(apiTimeout)
                        }
                        else {
                            this.setState({ 'workingStatus': res.status })
                        }
                    },
                    onFailure: () => {

                    }
                })

                this.props.getOneOffInputUploadStatus(res.templates[res.templates.length - 1]['_id'],
                    {
                        onSuccess: (res) => {
                            this.setState({ 'inputUrl': res.fileUrl })
                        },
                        onFailure: () => {

                        }
                    }
                )
                this.setState({ templates: res.templates, selectedTemplate: res.templates[res.templates.length - 1]['name'], templateId: res.templates[res.templates.length - 1]['_id'], fileTemplates: res.templates[res.templates.length - 1]['fileTemplates'] })
            },
            onFailure: () => {
            }
        })
    }


    dropDownTemplateOnChange = (e, data) => {
        data.options.map(async (d) => {
            if (d.value == data.value) {
                this.setState({ templateId: d.key })

                this.props.getRetailingExtractionStatus(d.key,
                    {
                        onSuccess: (res) => {
                            if(res.status == 'Completed'){
                                this.setState({psrInitial:false})
                            }
                            else if(res.status == 'Processing') {
                            this.setState({ 'extractionStatus': res.status,psrInitial:false })
                        }
                            else{
                                this.setState({psrInitial:true})
                            }
                            this.setState({ extractionStatus: res.status, fileUrl: res.fileUrl })
                        },
                        onFailure: () => {

                        }
                    }
                )
                this.props.getVisibilityReportStatus(d.key,
                    {
                        onSuccess: (res) => {
                            this.setState({ visibilityReportStatus: res.status, visibilityReportUrl: res.fileUrl })
                        },
                        onFailure: () => {

                        }
                    }
                )
                this.props.getoneOffFinalWorkingStatus(d.key, {
                    onSuccess: (res) => {

                        if (res.status == 'Completed') {
                            this.setState({ 'workingStatus': res.status, 'workingUrl': res.fileUrl, initial: false, downloadEnable: true })
                            clearTimeout(apiTimeout)
                        }
                        else if(res.status == 'Processing') {
                            this.setState({ 'workingStatus': res.status,initial:false })
                        }
                        else {
                            this.setState({ 'workingStatus': res.status,initial:true })
                        }
                    },
                    onFailure: () => {

                    }
                })
                this.props.getOneOffInputUploadStatus(d.key,
                    {
                        onSuccess: (res) => {
                            this.setState({ 'inputUrl': res.fileUrl })
                        },
                        onFailure: () => {

                        }
                    }
                )
            }
        })
        this.setState({ selectedTemplate: data.value })
    }

    dropDownDisbursementOnChange = (e, data) => {

        this.setState({ selectedDisbursement: data.value })
    }

    uploadFile = async (fileName, type) => {
        console.log(type, 'type')
        console.log(this.state.templateId, 'templateId')
        this.setState({ fileName: fileName, fileType: type, modalOpen: true })

    }

    closeuploadoption = () => {
        this.setState({ modalOpen: false })
    }

    fileupload = (file) => {
        this.setState({ currentFile: file.target.files[0], fileUploaded: true })
    };

    loadData = () => {
        this.props.getRetailingExtractionStatus(this.state.templateId,
            {
                onSuccess: (res) => {
                    if (res.status == 'Completed') {
                        this.setState({ extractionStatus: res.status, fileUrl: res.fileUrl,psrInitial:false })
                        clearTimeout(apiTimeout)
                    }
                    else {
                        this.setState({ extractionStatus: res.status })
                    }

                },
                onFailure: () => {

                }
            }
        )
        apiTimeout = setTimeout(this.loadData, 5000)
    }

    uploadRawFile = () => {
        this.setState({ loaderStatus: true })
        this.props.fetchRetailingPSR(this.state.currentFile, this.state.fileName, this.state.templateId, {
            onSuccess: (res) => {
                if (this.state.fileName == 'VisibilityReport') {
                    this.setState({ modalOpen: false, loaderStatus: false, visibilityReportStatus: 'Completed' })
                    alert('File Uploaded Success')
                }
                else if (this.state.fileName == 'oneoffInput') {
                    this.setState({ modalOpen: false, loaderStatus: false, inputUrl: res.fileUrl })
                    alert('File Uploaded Success')
                }
                
            },
            onFailure: () => {

            }
        })
    }

    downloadfile = (url) => {
        window.open(url);
    }

    start = () => {
        this.setState({
            workingStatus: 'Processing',
            initial: false
        })

        let data = {
            templateId: this.state.templateId
        }

        this.props.oneOffFinalWorking(data, {
            onSuccess: () => {
                apiTimeout = setTimeout(this.loadworkingData, 3000)
            },
            onFailure: () => {

            }
        })
    }

    loadworkingData = () => {
        this.props.getoneOffFinalWorkingStatus(this.state.templateId, {
            onSuccess: (res) => {

                if (res.status == 'Completed') {
                    this.setState({ workingStatus: res.status, workingUrl: res.fileUrl, downloadEnable: true, initial: false })
                    clearTimeout(apiTimeout)
                }
                else {
                    this.setState({ 'workingStatus': res.status })
                }
            },
            onFailure: () => {

            }
        })

        apiTimeout = setTimeout(this.loadworkingData, 3000)
    }

    startExtraction = ()=>{
        let data = {
            templateId:this.state.templateId
        }
        console.log(this.state.templateId,'templateId')
        this.props.extractRetailingData(data,{
            onSuccess:()=>{
                    apiTimeout = setTimeout(this.loadData, 5000)

            },
            onFailure:()=>{

            }
        })
    }




    render() {
        console.log(this.state.templateId, 'templateId')
        var templateMonths = []

        this.state.templates.map((d) => {
            templateMonths.push({
                'key': d._id,
                'value': d.name,
                'text': d.name
            })
        })

        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <p style={{ fontSize: 25 }}>
                        <h1
                            style={{

                                flex: "0 0 30px",
                                display: "inline-block",
                                color: "#2185d0",
                            }}
                        >
                            One-Off Displays Automation Process
                        </h1>
                    </p>
                    <div style={{ marginLeft: 10 }}>
                        <Dropdown placeholder='Select Template Month' search selection options={templateMonths}
                            onChange={this.dropDownTemplateOnChange}
                            value={this.state.selectedTemplate}
                        />
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.uploadFile('oneoffInput', 'oneoffInput')}
                        >

                            Upload Input
                            <Icon name="upload" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.downloadfile(storageBaseUrl + this.state.inputUrl)}
                        >

                            Download Input
                            <Icon name="download" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                </div>
                <Grid columns={4} style={{ marginTop: 20 }}>
                    <GridColumn>

                        <Card.Group>
                            <Card>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={processIcon}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <Card.Header>{'PSR Retailing Extraction'}</Card.Header>
                                    <br></br>
                                    <Card.Description>
                                        {`File Status : `}<strong style={{ color: this.state.extractionStatus == 'Completed' ? 'green' : this.state.extractionStatus == 'Processing' ? 'orange' : 'red' }}>{this.state.extractionStatus}</strong>
                                    </Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                        {this.state.psrInitial == true && (
                                            <Button basic color='green'
                                                onClick={() => this.startExtraction()}
                                            >
                                                <Icon name="hand point up" />
                                                Start
                                            </Button>
                                        )}
                                        {this.state.psrInitial == false && (
                                            <Button basic color='orange'
                                                onClick={() => this.startExtraction()}
                                            >
                                                <Icon name="redo" />
                                                Re-Start
                                            </Button>
                                        )}
                                        {this.state.psrInitial == false && (
                                            <Button basic color='green'
                                                onClick={() => this.downloadfile(storageBaseUrl + this.state.fileUrl)}
                                                disabled={this.state.extractionStatus == 'Completed' ? false : true}
                                            >
                                                <Icon name="download" />
                                                Download
                                            </Button>
                                        )}
                                    </div>
                                </Card.Content>
                            </Card>

                        </Card.Group>


                    </GridColumn>
                    <GridColumn>

                        <Card.Group>
                            <Card>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={processIcon}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <Card.Header>{'Visibility Report'}</Card.Header>
                                    <br></br>
                                    <Card.Description>
                                        {`File Status : `}<strong style={{ color: this.state.visibilityReportStatus == 'Completed' ? 'green' : this.state.visibilityReportStatus == 'Processing' ? 'orange' : 'red' }}>{this.state.visibilityReportStatus}</strong>
                                    </Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                        <Button basic color='red' onClick={() => this.uploadFile('VisibilityReport', 'visibilityReport')}
                                            disabled={this.state.visibilityReportStatus == 'Completed' ? true : false}
                                        >
                                            <Icon name="upload" />
                                            Upload
                                        </Button>
                                        <Button basic color='green'
                                            onClick={() => this.downloadfile(storageBaseUrl + this.state.visibilityReportUrl)}
                                            disabled={this.state.visibilityReportStatus == 'Completed' ? false : true}
                                        >
                                            <Icon name="download" />
                                            Download
                                        </Button>
                                    </div>
                                </Card.Content>
                            </Card>

                        </Card.Group>


                    </GridColumn>
                    <GridColumn>

                        <Card.Group>
                            <Card>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={processIcon}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <Card.Header>{'One Off Display Process'}</Card.Header>
                                    <br></br>
                                    <Card.Description>
                                        {`File Status : `}<strong style={{ color: this.state.workingStatus == 'Completed' ? 'green' : this.state.workingStatus == 'Processing' ? 'orange' : 'red' }}>{this.state.workingStatus}</strong>
                                    </Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                        {this.state.initial == true && (
                                            <Button basic color='green'
                                                onClick={() => this.start()}
                                            >
                                                <Icon name="hand point up" />
                                                Start
                                            </Button>
                                        )}
                                        {this.state.initial == false && (
                                            <Button basic color='orange'
                                                onClick={() => this.start()}
                                            >
                                                <Icon name="redo" />
                                                Re-Start
                                            </Button>
                                        )}
                                        {this.state.initial == false && (
                                            <Button basic color='green'
                                                onClick={() => this.downloadfile(storageBaseUrl + this.state.workingUrl)}
                                                disabled={this.state.downloadEnable == true ? false : true}
                                            >
                                                <Icon name="download" />
                                                Download
                                            </Button>
                                        )}

                                    </div>
                                </Card.Content>
                            </Card>

                        </Card.Group>


                    </GridColumn>
                </Grid>
                <Modal
                    open={this.state.modalOpen}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h4>Upload Master data :</h4>
                                        <Input
                                            type="file"
                                            accept=".xlsx"
                                            onChange={this.fileupload}
                                            multiple
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.uploadRawFile}
                                title={'Upload'}
                                color={'green'}
                                iconColor={'white'}
                                disabled={this.state.fileUploaded == true ? false : true}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>

            </div>




        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchRetailingPSR,
            fetchTemplates,
            getRetailingExtractionStatus,
            getVisibilityReportStatus,
            getOneOffInputUploadStatus,
            oneOffFinalWorking,
            getoneOffFinalWorkingStatus,
            extractRetailingData

        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Automation));
